import * as yup from 'yup';
import moment from 'moment';
import { ActivityType } from '../../UserActivity.meta';

export const activityTypeOptions = [
  { value: ActivityType.DeliveryOfPlan, label: 'Delivery of Plan' },
  { value: ActivityType.OtherActivity, label: 'Other Activity' },
];

export const MAX_ACTIVITY_NAME_CHARS = 200;
export const MAX_COMMENT_CHARS = 2500;

export const validation = yup.object().shape({
  date: yup
    .string()
    .required('Please, insert a valid date and time.')
    .test('is-future-date', 'Date cannot be in the future.', value => {
      if (!value) {
        // Let the .required() test handle it
        return true;
      }

      return moment.utc(value).isBefore(moment.utc());
    }),

  activityName: yup.string().when('activityType', {
    is: status => status === ActivityType.OtherActivity,
    then: yup.string().required('Please, insert the name of the activity.'),
  }),
});
